import React from "react";
// import { useLocation } from "react-router-dom";
import CssBaseline from "@mui/material/CssBaseline";
import Header from "../../components/shared/Header";
import Footer from "../../components/shared/Footer";

interface LayoutProps {
  children: React.ReactNode;
}

function Layout({ children }: LayoutProps) {
  //   const location = useLocation();

  //   const isAuthPage = location.pathname === "/auth";

  return (
    <>
      <CssBaseline />
      <Header />{" "}
      <main
        style={{
          paddingTop: "110px",
          backgroundImage: "url(/assets/backgroundsvg.svg)",
          backgroundRepeat: "repeat-y",
          backgroundSize: "100%",
        }}
      >
        {children}
      </main>
      <Footer />
    </>
  );
}

export default Layout;
